// Analytics constants:
export const EDIT_SYNC_JOB_STEPPER_STEPS = 6;
export const EDIT_SYNC_JOB = 'editSyncJob';
